import {PaymentModeMapping} from '../models/payment-method.model';

export class AppConstants {

  public static readonly ANNOUNCEMENT_DISPLAY_MODE = 'ANNOUNCEMENT_DISPLAY_MODE';

  public static readonly CASE_NUMBER_INVALID = 'Invalid Case Number and/or Subcase Number. Click on "Where to find the details" for more information on where to locate the Case/Subcase number in your letter, where applicable. Please reach out to the Court Officer who had handed you the letter for further assistance, if necessary.Alternatively, you can contact us via email "contact@judiciary.gov.sg" or call 1800 587 8423.';
  public static readonly ERROR_INVALID_PAC_NUMBER = 'Invalid Payment Reference/Invoice Number.';
  public static readonly DEPOSIT_AMOUNT_MAX_LIMIT = '99999999.99';
  public static readonly DEPOSIT_PAC_PREFIX = 'PAC9';
  public static readonly OTHER_DEPOSIT = 'OTHER_DEPOSIT';
  public static readonly SID = 'SID';
  public static readonly SICC = 'SICC';
  public static readonly SHERIFF_BAILIFF_DEPOSIT = 'SHERIFF_BAILIFF_DEPOSIT';
  public static readonly ERROR_SERVICE_UNAVAILABLE = 'The service is currently unavailable. Please try again after sometime. If the issue persists, contact customer support for assistance.';
  public static readonly RETRIEVE_PAYMENT_NOTE = ' This information can be indicated on Payment Advice/Invoice.';
  public static readonly QR_NOTE = ' Upon completion of PayNow through your banking app, please close this text message and proceed to the next page.';
  public static readonly CHEQUE_NOTE = ' Cheque payment is not applicable for Court Fees or Bail/Bond payments.';
  public static readonly PROCESS_PAYMENT_FAIL_ERROR_MESSAGE = "Cheque payment process is failed. Please contact support for further assistance.";
  public static readonly DEPOSIT_PAYMENT_FAIL_ERROR_MESSAGE = "Deposit payment process is failed. Please contact support for further assistance.";
  public static readonly CHEQUE_NOTE1 = " Cheque/Cashier’s Order option will be available for one of the physical terminals in State Courts, located at Level 4.";
  public static readonly CAPTCHA_ERROR_MESSAGE = "Error occurred while verifying the captcha. Please contact support team.";

  public static readonly DEFAULT_IDLE_TIMEOUT_DURATION_IN_MINUTES = 15;

  public static readonly DEFAULT_WARNING_MINUTES_BEFORE_IDLE_TIMEOUT = 2;

  public static readonly MESSAGE_CLEAR_DELAY_MS = 15000 //15 seconds delay;

  public static getDisplayMessage(messageCode: string) {
    if ('contact_support' === messageCode) {
      return 'Something went wrong. Please contact administrator!';
    } else if ('processed_successful' === messageCode) {
      return 'Payment processes successfully!'
    } else if ('payment_failed' === messageCode) {
      return 'Payment failed. Please contact administrator!'
    } else if ('unexpected_payment_response' === messageCode) {
      return 'Unexpected payment response. Please contact administrator!'
    } else if ('payment_processing' === messageCode) {
      return 'Your previous payment might still be under processing. Please wait before trying again.'
    }
    return "Please contact administrator!"
  }

  private static formatNumber(value: number | null | undefined, options: Intl.NumberFormatOptions = {}): string {
    if (value == null) return '0.00';
    return value.toLocaleString('en-SG', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      ...options,
    });
  }

  public static showAmountFormatted(value: number | null | undefined): string {
    return `$${this.formatNumber(value)}`;
  }

  public static inputAmountFormatted(value: number | null | undefined): string {
    return this.formatNumber(value, { useGrouping: false });
  }

  public static getPaymentMode(mode: string): string {
    const normalized = mode?.trim().toUpperCase();
    if (!normalized) return 'N/A';
    for (const [key, value] of Object.entries(PaymentModeMapping)) {
      if (value.codes.includes(normalized)) {
        return key; // always returns the canonical enum-like key
      }
    }
    return 'N/A';
  }

  public static handleDropdownKey(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      (event.target as HTMLElement).click();
    }
  }
}
